import axios from "axios";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./index.css";
import getDate from "../../../../utils/getDate";
import MySteps from "../../components/MySteps";
import { updateAlert } from "../../redux/actions";
import VPPResult from "../../components/RegressionResult";
// import PDFRender from "../../components/PDFRender";
import Queuing from "./Queuing";
import Failed from "./Failed";
import BinaryClass from "./BinaryClass";
import PerformanceArea from "./PerformanceArea";

function Results(props) {

  const [searchParams] = useSearchParams();
  const rid = searchParams.getAll("rid")[0];

  const navigate = useNavigate();

  const [result, setResult] = useState({});
  const [stepItems, setStepItems] = useState([]);
  const [files, setFiles] = useState([]);

  const [currStep, setCurrStep] = useState("Queuing");
  const [groundTruth, setGroundTruth] = useState([]);

  const [showPDF, setShowPDF] = useState(false);


  useEffect(() => {
    axios({
      method: "get",
      url: `/api/m2d/results/${rid}`,
    }).then((res) => {
      if (res.data) {
        if (res.data.result.dataSaved !== null && res.data.files) {
          setFiles(res.data.files);
        }
        const tmp = [];
        setResult(res.data.result);
        const jobStatuses = res.data.result.m2dJobStatuses;
        const queuing_index = jobStatuses.findIndex(
          (status) => status.status === "Queuing"
        );
        const processing_index = jobStatuses.findIndex(
          (status) => status.status === "Processing"
        );
        if (processing_index !== -1) {
          // if processing status exists
          // set queuing state as finished
          tmp.push({
            title: "Queuing",
            description: getDate(jobStatuses[queuing_index].time),
            status: "finish",
          });

          const done_index = jobStatuses.findIndex(
            (status) => status.status === "Done"
          );
          const failed_index = jobStatuses.findIndex(
            (status) => status.status === "Failed"
          );

          if (done_index !== -1 || failed_index !== -1) {
            tmp.push({
              title: "Processing",
              description: getDate(jobStatuses[processing_index].time),
              status: "finish",
            });
            if (done_index !== -1) {
              tmp.push({
                title: "Done",
                description: getDate(jobStatuses[done_index].time),
                status: "finish",
              });
              setCurrStep("Done");
            } else {
              tmp.push({
                title: "Failed",
                description: getDate(jobStatuses[failed_index].time),
                status: "error",
              });
              setCurrStep("Failed");
            }

            setStepItems(tmp);
          } else {
            tmp.push({
              title: "Processing",
              status: "process",
            });
            tmp.push({
              title: "Done",
              status: "wait",
            });
            setStepItems(tmp);
            setCurrStep("Processing");
          }
        } else {
          setStepItems([
            {
              title: "Queuing",
              description: getDate(jobStatuses[queuing_index].time),
              status: "process",
            },
            {
              title: "Processing",
              status: "wait",
            },
            {
              title: "Done",
              status: "wait",
            },
          ]);
        }
      } else {
        navigate("/login");
      }
    });
  }, [navigate, rid, props]);

  const handlePDF = () => {
    setShowPDF(curr => !curr);
  }

  return (
    <div className="page-content">
      <div className="steps-bar">
        <MySteps items={stepItems} />
      </div>

      {(currStep === "Queuing" || currStep === "Processing") &&
        <Queuing currStep={currStep} />
      }

      { currStep === "Failed" && <Failed result={result} /> }

      {currStep === "Done" && result && result.value &&
        <div className="results">
          <div className="res-model-name">{result.m2dModel.name}</div>
          {result.m2dModel.m2dModelResultType.type === 'binary classification' && 
            <BinaryClass
              result={result}
              groundTruth={groundTruth}
              setGroundTruth={setGroundTruth}
              files={files}
            />}

          {result.m2dModel.name === "Vehicle Price Prediction" && 
            <div className="bcs">
              <VPPResult
                results={JSON.parse(result.value).results}
                filenames={JSON.parse(result.fileName).filenames}
                rid={result.id}
                uid={props.user.id}
              />
            </div>
          }

          {/* <PDFRender cm={CM} hidden={!showPDF} /> */}

          <PerformanceArea
            groundTruth={groundTruth}
            setGroundTruth={setGroundTruth}
            showPDF={showPDF}
            handlePDF={handlePDF}
            result={result}
          />
        </div>
      }
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.main.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleAlert(alertType, alertMessage, time = 2500) {
      updateAlert(alertType, alertMessage, time)(dispatch);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Results);
